import { gql } from '@apollo/client';

export interface LeaveCarpoolTripMutation {
  leaveCarpoolTrip: {
    id: string;
  };
}

export interface LeaveCarpoolTripMutationVariables {
  tripId: string;
}

export const LEAVE_CARPOOL_TRIP = gql`
  mutation LeaveCarpoolTrip($tripId: ID!) {
    leaveCarpoolTrip(tripId: $tripId) {
      id
    }
  }
`;
